import { TypeKeys } from '../actions';
import { MapInstanceState } from './map.reducer';

export interface MapUpdateStateAction {
  type: TypeKeys.MAP_UPDATE_STATE;
  state: MapInstanceState;
}

export type MapActions =
  | MapUpdateStateAction;



export const mapUpdateState = (state: MapInstanceState): MapUpdateStateAction => ({
  type: TypeKeys.MAP_UPDATE_STATE,
  state
});
